<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12">
        <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="range !== null" v-scroll-reveal="{delay: 0}">
      <div class="col">
        <h1>{{ range.name }}</h1>
      </div>
    </div>
    <div class="row mt-3" v-if="categories !== null" v-scroll-reveal="{delay: 0}">
      <router-link
        tag="div"
        class="col-12 col-sm-6 col-md-4"
        v-for="category in categories"
        :key="category.id"
        :to="`/ranges/${rangeId}/categories/${category.id}/`"
      >
        <div class="sub-category">
          <div
            class="sub-category__background"
            :style="{backgroundImage: `url('${category.imageUri}')`}"
          >
            <div class="sub-category__inner-container">
              <h2 class="sub-category__text">{{category.name}}</h2>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["ranges"]),
    rangeId() {
      return this.$route.params.rangeId;
    },
    range() {
      return this.ranges[this.rangeId] || {};
    },
    categories() {
      return this.range ? this.range.categories : null;
    },
    breadcrumbs() {
      const { range } = this;

      let breadcrumbs = [];

      if (range) {
        breadcrumbs.push({
          text: range.name,
          active: true
        });
      }

      return breadcrumbs;
    }
  }
};
</script>

<style lang="scss">
.sub-category {
  font-size: 1rem;
  height: 16em;
  width: 100%;
  margin: 15px auto;
  cursor: pointer;
  overflow: hidden;

  .sub-category__background {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
    background-size: cover;
    overflow: hidden;
    transition: transform 0.25s, visibility 0.25s ease-in;

    &:hover {
      transform: scale(1.16);
    }
  }

  .sub-category__inner-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
  }

  .sub-category__text {
    font-size: 2em;
    font-weight: 700;
    text-align: center;
    padding: 1em;
    color: white;
  }
}
</style>